export const validateEmail = (str) => {
  const isEmail = /^[a-z0-9._-]{1,64}@[a-z0-9._-]{1,64}$/i.test(str);
  return isEmail;
};
